import { Alert } from "@mui/material";
const SchemaNotFoundAlert = ({ schemaNotFound, message }) => {
  return schemaNotFound && <Alert severity="warning">{message}</Alert>;
};
export default SchemaNotFoundAlert;
